import {
  DialogContent as UiDialogContent,
  DialogDescription as UiDialogDescription,
  DialogHeader as UiDialogHeader,
  DialogTitle as UiDialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

import {
  dialogCloseVariants,
  dialogContentVariants,
  dialogDescriptionVariants,
  dialogHeaderVariants,
  dialogOverlayVariants,
  dialogTitleVariants,
} from '../../configs/dialog.config'

import type { ComponentProps } from 'react'

export { Dialog } from '@/components/ui/dialog'

export function DialogContent({
  className,
  overlayClassName,
  closeClassName,
  ...props
}: ComponentProps<typeof UiDialogContent>) {
  return (
    <UiDialogContent
      {...props}
      className={cn(dialogContentVariants(), className)}
      overlayClassName={cn(dialogOverlayVariants(), overlayClassName)}
      closeClassName={cn(dialogCloseVariants(), closeClassName)}
    />
  )
}

export function DialogHeader({ className, ...props }: ComponentProps<typeof UiDialogHeader>) {
  return <UiDialogHeader {...props} className={cn(dialogHeaderVariants(), className)} />
}

export function DialogTitle({ className, ...props }: ComponentProps<typeof UiDialogTitle>) {
  return <UiDialogTitle {...props} className={cn(dialogTitleVariants(), className)} />
}

export function DialogDescription({ className, ...props }: ComponentProps<typeof UiDialogDescription>) {
  return <UiDialogDescription {...props} className={cn(dialogDescriptionVariants(), className)} />
}
